import {GetBeneficiaryParams} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {makeGetBeneficiary} from 'main/factories/usecases/others/selection-flow/remote-beneficiary-v3';

import {sortByKey} from 'presentation/utils';

export const getBeneficiaries = async (params: GetBeneficiaryParams) => {
	if (!params.nuContrato) {
		return [];
	}
	const beneficiariesList = await makeGetBeneficiary().get(params);

	const sortedBeneficiariesBySocialName = sortByKey(
		beneficiariesList.beneficiarios,
		'nmSocialUsuarioC',
	);
	return sortedBeneficiariesBySocialName;
};
